<template>
    <component :is="{}" v-bind="linkProps(to, disabled)">
        <slot />
    </component>
</template>

<script>
export default {
    name: 'SrAppLink',
    props: {
        to: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        linkProps(url, disabled) {
            const isExternalUrl = url.match(/^(http(s)?|ftp):\/\//) || url.startsWith('//');
            if (isExternalUrl) {
                return {
                    is: 'a',
                    href: disabled ? '' : url,
                    target: '_blank',
                    rel: 'noopener',
                };
            }
            return {
                is: 'router-link',
                to: url,
                event: disabled ? '' : 'click',
            };
        },
    },
};
</script>
